import { useSnackbar } from 'notistack'
import { t } from '@lingui/macro'

import { useCreatePatientMutation } from '@/core/services/patient'
import { buildEmergencyPatientDto } from '@/features/patient/emergency-patient'
import { useIsSA } from '@/hooks/useIsSA'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { getApiErrorMessage } from '@/utils/errors'
import { SelectedPatient } from './useSimplifiedReception'

/** One click, like the usual "Emergency patient" button: creates the emergency placeholder patient. */
export function useCreateEmergencyPatient() {
  const isSA = useIsSA()
  const authUser = useAppSelector(selectAuthUser)
  const { enqueueSnackbar } = useSnackbar()
  const [createPatient, { isLoading }] = useCreatePatientMutation()

  const create = async (): Promise<SelectedPatient | undefined> => {
    try {
      const patient = await createPatient(buildEmergencyPatientDto({ isSA, language: authUser?.userInfo?.language })).unwrap()
      return { id: patient._id, label: `${patient.userInfo.name} ${patient.userInfo.surname}` }
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, t`The emergency patient could not be created`), { variant: 'error' })
      return undefined
    }
  }

  return [create, isLoading] as const
}
